import { Box, Typography } from '@mui/material';
import plusIcon from 'assets/icons/plus-icon.svg';
import { SecondaryButton } from 'components/lib/SecondaryButton';
import { StepFooterActions } from 'components/StepFooterActions';
import { SvgIconWrapper } from 'components/SvgIconWrapper';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import { ExposuresWrapperDescriptionStyle, ExposuresWrapperStyle } from './ExposuresWrapper.styles';
import type { ExposuresWrapperProps } from './ExposuresWrapper.types';

const ExposuresWrapper: FC<ExposuresWrapperProps> = ({
  children,
  title,
  description,
  addButtonText,
  onAddBtnClick,
  onNext,
  onPrevious,
  renderAddButton = true,
  disableActions,
  nextBtnText,
  extraContentAfterAddButton,
  ...rest
}) => (
  <Box {...rest} sx={[ExposuresWrapperStyle, ...castArray(rest.sx)]}>
    <Box>
      <Typography variant="h1">{title}</Typography>

      {description && <Typography sx={ExposuresWrapperDescriptionStyle}>{description}</Typography>}
    </Box>

    {children}

    {renderAddButton && (
      <SecondaryButton
        data-test={addButtonText}
        onClick={onAddBtnClick}
        startAdornment={<SvgIconWrapper src={plusIcon} />}
        text={addButtonText || 'Add'}
      />
    )}

    {extraContentAfterAddButton}

    <StepFooterActions
      onNext={onNext}
      onPrevious={onPrevious}
      disableActions={disableActions}
      nextBtnText={nextBtnText}
    />
  </Box>
);

export default ExposuresWrapper;
